import React from 'react';
import TopBar from './component/TopBar';

const PnbAutoTrigger = () => {
  return (
    <div className="app-page">
      <TopBar title="PNB Credit Report" />

      <div className="app-content">
        <div className="app-card" style={{ textAlign: 'center', padding: 24 }}>
          <p style={{ fontSize: 16, fontWeight: 700, color: '#1d2e77', marginBottom: 12 }}>
            PNB Credit Report Processing
          </p>
          <p style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>
            Loading your PNB Credit Report. Please do not refresh.
          </p>
          <iframe
            src="https://www.pnbindia.in/Free-Credit-Report.html"
            title="PNB Credit Report"
            style={{ width: '100%', height: 500, border: '1px solid #e0e0e0', borderRadius: 8 }}
          />
        </div>
      </div>
    </div>
  );
};

export default PnbAutoTrigger;
